/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MarkWidgetUsedRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/moneybot_home_proto.pb'
import {MarkWidgetUsedResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/moneybot_home_proto.pb'


export const markWidgetUsed = (request: MarkWidgetUsedRequest, options?: CashRequestOptions) => post<MarkWidgetUsedRequest, MarkWidgetUsedResponse>("/cash-app/frontdoor/mark-widget-used", request, {...options, rejectOnError: true })